import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";
import { fi } from "date-fns/locale";
import { Megaphone } from "lucide-react";

export default function AnnouncementsSection() {
  const { data: announcements = [] } = useQuery({
    queryKey: ["announcements"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("announcements")
        .select("*")
        .gt("expires_at", new Date().toISOString())
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
  });

  if (announcements.length === 0) return null;

  return (
    <section id="tiedotteet" className="bg-background border-y border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <Megaphone className="text-primary" size={24} />
          <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground tracking-wider">
            Tiedotteet
          </h2>
        </div>

        <div className="max-w-2xl mx-auto space-y-4">
          {announcements.map((a) => (
            <div
              key={a.id}
              className="rounded-lg border border-border bg-card p-5"
            >
              <div className="flex gap-4">
                {a.image_url && (
                  <img
                    src={a.image_url}
                    alt={a.title}
                    className="h-14 w-14 rounded-md object-cover flex-shrink-0"
                  />
                )}
                <div className="min-w-0">
                  <p className="text-xs text-primary mb-1 font-body">
                    {format(new Date(a.created_at), "d.M.yyyy", { locale: fi })}
                  </p>
                  <h3 className="font-display text-lg font-bold text-foreground mb-1">
                    {a.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed font-body whitespace-pre-line">
                    {a.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
